import { get, post } from './http-calls';

export let getTCardWorkTypesByID = async (id) => {
    let data = await get(`TCardWorkTypes/TCardWorkTypesGetDetails?TCardWorkTypeID=${id}`, { useAuthToken: true });
    return data;
};
export let fetchWorkTypeDropdown = async () => {
    let data = await get(`TCardWorkTypes/TCardEventType`, { useAuthToken: true });
    return data;
};

export const postTCardWorkTypes = async (data) => {
    let res = await post(`TCardWorkTypes/TCardWorkTypesAddUpdate`, data, { useAuthToken: true });
    return res;
};